import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import { DashboardTypes } from "aw-consts";
import { getLast7days, getTodayDate } from "aw-date-functions";
import MachineStatus from "../components/MachineStatusComponent/MachineStatus.component";
import { Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { getRandomNumber, orderByLabel } from "aw-generic-functions";
import { AwCarousel } from "aw-carousel";
import RuleCard from "../components/RuleCard/RuleCard.component";
import AlarmsBarChart from "../components/AlarmsBarChart/AlarmsBarChart.components";
import AlarmsPieChart from "../components/AlarmsPieChart/AlarmsPieChart.components";
import { Instalation } from "../utils/models/Instalation";
import { ISelectOptions } from "aw-combobox";
import { Machine } from "../utils/models/Machine";
import SearchBar from "../components/ButtonsLineComponent/SearchBar.component";
import { getMachinesByInstallation } from "../utils/services/machine.service";
import { getInstalationsByCompany } from "../utils/services/instalation.service";
import ModalAlarm from "../components/ModalAlarm/ModalAlarm.component";
import { useTheme } from "../utils/contexts/ThemeContext";
import { isTabletScreen } from "../utils/const";


export interface Rule {
    id?: string,
    name: string,
    description?: string,
    param: string,
    paramUnits?: string,
    min?: number | null,
    max?: number | null,
    active: boolean,
    severity: SeverityType,
    installation?: number | null,
    machines?: number[],
    emails?: string[]
}

export enum SeverityType {
    Minor = 1,
    Warning = 2,
    Critical = 3
}

const mockRules: Rule[] = [
    { id: '1', name: 'Rule 8', description: "Description of the rule’s triggering condition: the specific event or threshold that activates the rule.", param: 'Param 8', active: true, installation: 21, machines: [], severity: SeverityType.Warning, emails: ['user1@awayter.com', 'user2@awayter.com'], min: 20, max: 35, paramUnits: 'º' },
    { id: '2', name: 'Rule 7', description: "Description of the rule’s triggering condition", param: 'Param 7', active: true, installation: 21, machines: [], severity: SeverityType.Critical, emails: ['user1@awayter.com'], min: 20, paramUnits: '%' },
    { id: '3', name: 'Rule 6', description: "Description of the rule’s triggering condition", param: 'Param 6', active: true, installation: 21, machines: [], severity: SeverityType.Warning, emails: [], max: 900, paramUnits: 'Kw' },
    { id: '4', name: 'Rule 5', description: "Description of the rule’s triggering condition", param: 'Param 7', active: true, installation: 21, machines: [], severity: SeverityType.Minor, emails: [], min: 40, paramUnits: '%' },
    { id: '5', name: 'Rule 4', description: "Description of the rule’s triggering condition", param: 'Param 4', active: false, installation: 21, machines: [], severity: SeverityType.Warning, emails: [], min: 100, max: 800, paramUnits: 'm³/h' },
    { id: '6', name: 'Rule 3', description: "Description of the rule’s triggering condition", param: 'Param 6', active: false, installation: 21, machines: [], severity: SeverityType.Critical, emails: [], min: 20, max: 1000, paramUnits: 'kw' },
    { id: '7', name: 'Rule 2', description: "Description of the rule’s triggering condition", param: 'Param 5', active: false, installation: 21, machines: [], severity: SeverityType.Critical, emails: [], min: 20, max: 35, paramUnits: 'º' },
    { id: '8', name: 'Rule 1', description: "Description of the rule’s triggering conditio", param: 'Param 4', active: false, installation: 21, machines: [], severity: SeverityType.Minor, emails: [], min: 20, max: 35, paramUnits: 'º' }
];

const AlarmModulePage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext()
    const [iniDate, setIniDate] = useState(getLast7days())
    const [finDate, setFinDate] = useState(getTodayDate())
    const [loadingData, setLoadingData] = useState(true)
    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1000);
    const [rules, setRules] = useState<Rule[]>(mockRules)
    const [selectedRule, setSelectedRule] = useState<Rule | null>()

    const [installations, setInstallations] = useState<Instalation[]>([])
    const [allInstalationsObj, setAllInstalationsObj] = useState<ISelectOptions[]>([])
    const [selectedInstallation, setSelectedInstallation] = useState<ISelectOptions>()
    const [machines, setMachines] = useState<Machine[]>([])
    const [allMachinesObj, setAllMachinesObj] = useState<ISelectOptions[]>([])
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions>()

    const [showModal, setShowModal] = useState(false)

    const { idinstalation } = useParams();
    const { idmachine } = useParams();

    const theme = useTheme()

    const data01 = [
        { name: "Param 8", value: getRandomNumber(1, 100) },
        { name: "Param 7", value: getRandomNumber(1, 100) },
        { name: "Param 6", value: getRandomNumber(1, 100) },
        { name: "Param 4", value: getRandomNumber(1, 100) }
    ];

    useEffect(() => {
        context.setState(t('Alarms'));
    }, [context, t]);

    const onChangeDates = (e: any) => {
        if (e.target.name === "iniDate") {
            setIniDate(e.target.value)
        } else if (e.target.name === "finDate") {
            setFinDate(e.target.value)
        }
    }

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1000);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const reloadButtonClick = () => {
        setLoadingData(true)
        setTimeout(() => setLoadingData(false), 500)
    }

    useEffect(() => {
        getInstalationsByCompany(user.token, user.company.idcompany)
            .then((i: Instalation[]) => {
                if (i.length === 0) throw new Error('No Installations');

                setInstallations(i);

                const iObj = orderByLabel(i.map((i: Instalation) => ({
                    label: i.name,
                    value: i.idinstalation
                })));

                // Insertar la opción de "All Installations"
                const allOption = { label: t('AllInstallations'), value: -1 };
                setAllInstalationsObj([allOption, ...iObj]);

                let selectedInstAux = allOption; // default

                if (idinstalation) {
                    const found = i.find((ins) => ins.idinstalation === parseInt(idinstalation));
                    if (found) selectedInstAux = { label: found.name, value: found.idinstalation };
                }
                setSelectedInstallation(selectedInstAux);
            })
            .catch((e) => {
                console.error('Error getInstalationsByCompany', e);
            })
            .finally(() => {
                setTimeout(() => setLoadingData(false), 250);
            });
    }, []);


    useEffect(() => {
        if (selectedInstallation && selectedInstallation.value !== -1) {
            getMachinesByInstallation(user.token, Number(selectedInstallation.value))
                .then((m: Machine[]) => {
                    if (m.length === 0) throw new Error('No Machines');

                    setMachines(m);

                    const mObj = orderByLabel(m.map((m: Machine) => ({
                        label: m.name,
                        value: m.idmachine
                    })));

                    const allOption = { label: t('AllMachinesSelect'), value: -1 };
                    const updatedMachines = [allOption, ...mObj];
                    setAllMachinesObj(updatedMachines);

                    let selectedMachAux = allOption;

                    if (idmachine) {
                        const found = m.find((mac) => mac.idmachine === parseInt(idmachine));
                        if (found) selectedMachAux = { label: found.name, value: found.idmachine };
                    }

                    setSelectedMachine(selectedMachAux);
                })
                .catch((e) => console.error("Error getMachinesByInstallation:", e))
                .finally(() => setTimeout(() => setLoadingData(false), 250));
        } else {
            // Si es selecciona All Installations
            const allOption = { label: t('AllMachinesSelect'), value: -1 };
            setAllMachinesObj([allOption]);
            setSelectedMachine(allOption);
        }
    }, [selectedInstallation]);


    const handleSave = (rule: Rule) => {
        console.log('handleSave', rule);
        setRules((prevItems) => {
            const index = prevItems.findIndex((i) => i.id === rule.id);
            if (index !== -1) {
                // Editar
                const updated = [...prevItems];
                updated[index] = rule;
                return updated;
            } else {
                // Crear
                return [...prevItems, rule];
            }
        });
        setShowModal(false);
        setSelectedRule(null);
    };

    const handleDelete = (rule: Rule) => {
        console.log('handleDelete', rule);
        setRules((prevItems) => prevItems.filter((i) => i.id !== rule.id));
    }

    const handleHide = () => {
        console.log('handleHide');
        setShowModal(false);
        setSelectedRule(null);
    }

    return (
        <>
            <ModalAlarm showModal={showModal} rule={selectedRule} installations={allInstalationsObj} onHide={() => handleHide()} onSave={(rule) => handleSave(rule)} />
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <SearchBar role={user.role} defaultIni={iniDate} company={(user.company.name)} disableMachineSelect={selectedInstallation?.value === -1}
                        defaultFin={finDate} onChangeDates={onChangeDates} onChangeSelect={(selectedInstallation) => { setSelectedInstallation(selectedInstallation) }}
                        onClickReload={reloadButtonClick} options={allInstalationsObj} selected={selectedInstallation || { label: "", value: 0 }} rounded='rounded-1'
                        classNameSuccess='btn-Custom btn-IDGreen' containerColor='var(--background-secondary)' dark={theme.theme === 'dark' ?  true : false} downloadButton={false} optionsFilter2={allMachinesObj}
                        selectedFilter2={selectedMachine || { label: "", value: 0 }} onChangeSelect2={(selectedMachine) => { setSelectedMachine(selectedMachine) }} showCompaniesCombo={false} />
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-2 px-1 mt-1'>
                    <div className="d-flex flex-column align-items-center justify-content-center pt-2  rounded-1" style={{ height: '100%', backgroundColor: 'var(--background-secondary)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        <button onClick={() => { setShowModal(true) }} className='btn-big btn-IDGreen buttonRadius'><i className="bi bi-plus"></i></button>
                        <h2 className="text-center" style={{color: 'var(--text-primary)'}}>{t('NewRule')}</h2>
                    </div>
                </div>
                <div className='col-12 col-md-10 mb-1 mb-sm-0 px-1 mt-1'>
                    <AwCarousel
                        items={rules}
                        rows={isWideScreen ? 2 : 2}
                        cols={isWideScreen ? 3 : 1}
                        activePageIndicatorColor="var(--accent-color)"
                        // nonActivePageIndicatorColor="var(--IDBlack)"
                        footerColor="var(--background-secondary)"
                    >
                        {(item: Rule) =>
                            <RuleCard isTablet={isTabletScreen()} rule={item} onEdit={(rule) => { setShowModal(true); setSelectedRule(rule) }} onDelete={(rule) => { handleDelete(rule) }}></RuleCard>
                        }
                    </AwCarousel>
                </div>
            </div>
            <div className='row border-0 ms-2 me-2 mt-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-sm-4 col-md-5 px-1 '>
                    <MachineStatus updLastConnection={() => null} id={user.company.idcompany} token={user.token} refresh={loadingData} title={t('Status')} dashboardType={DashboardTypes.Company} user={user} iniDate={iniDate} finDate={finDate} />
                </div>
                <div className='col-12 col-sm-8 col-md-7 mb-2'>
                    <div className="row">
                        <div className='col-12 px-1 col-md-6 '>
                            <section className="rounded-1 text-center pt-2" style={{ backgroundColor: 'var(--background-secondary)', height: '248px', color: 'var(--text-primary)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                                <ResponsiveContainer width="100%" height="90%">
                                    <PieChart width={100} height={100}>
                                        <Pie
                                            dataKey="value"
                                            isAnimationActive={true}
                                            data={data01}
                                            cx="50%"
                                            cy="50%"
                                            outerRadius={60}
                                            fill="#19DAAD"
                                            label={({ cx, cy, midAngle, innerRadius, outerRadius, value, name }) => {
                                                const RADIAN = Math.PI / 180;
                                                const radius = 25 + outerRadius;
                                                const x = cx + radius * Math.cos(-midAngle * RADIAN);
                                                const y = cy + radius * Math.sin(-midAngle * RADIAN);

                                                return (
                                                    <text
                                                        x={x}
                                                        y={y}
                                                        fill="var(--text-primary)"
                                                        textAnchor={x > cx ? "start" : "end"}
                                                        dominantBaseline="central"
                                                    >
                                                        {/* {`${name} (${value})`} */}
                                                        {`${name}`}
                                                    </text>
                                                );
                                            }}

                                        />
                                        <Tooltip />
                                    </PieChart>
                                </ResponsiveContainer>
                            </section>
                        </div>
                        <div className='col-12 px-1 col-md-6  ' >
                            <AlarmsPieChart ></AlarmsPieChart>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-12 px-1 mt-md-2'>
                            <AlarmsBarChart dark={theme.theme === 'dark'}></AlarmsBarChart>
                        </div>
                    </div>

                </div>
                {/* <div className='col-12 col-sm-8 col-md-7 mb-1 mb-sm-0 px-1 mt-1'>
                    <AlarmParameters />
                </div> */}
            </div>


            {/* <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>

                <div className='col-12 col-lg px-1 mt-2'>
                    <DataCircle refresh={false} title={t('MachinesWithError')} data={getRandomNumber(0, 50)} color={3} units='u' />
                </div>
                <div className='col-12 col-lg px-1 mt-2'>
                    <DataCircle refresh={false} title={t('TimeWithError')} data={getRandomNumber(1, 10)} color={2} units='m' />
                </div>
            </div> */}
        </>
    )
}

export default AlarmModulePage